export const environment = {
  production: false,
  wsUrl: 'wss://ws.dev.api.synopsis.rozie.ai',
  apiUrl: 'https://dev.api.synopsis.rozie.ai',
  X_API_KEY: 'B7YTICPnCP93axNfbqrEH7Bn8V3E3t4i4rtOJmk7',
};
